import React from 'react';

const STATUS_STYLES = {
  // order / document status
  PENDING: 'bg-yellow-100 text-yellow-800',
  PARTIAL: 'bg-blue-100 text-blue-800',
  COMPLETED: 'bg-green-100 text-green-800',
  CANCELLED: 'bg-red-100 text-red-800',
  REJECTED: 'bg-red-100 text-red-800',
  // PI item stock status
  'to-be-reserved': 'bg-yellow-100 text-yellow-800',
  'to-be-ordered': 'bg-red-100 text-red-800',
  'to-be-billed': 'bg-blue-100 text-blue-800',
  'goods-received': 'bg-green-100 text-green-800',
  // payment status
  TOTAL_CREDIT: 'bg-red-100 text-red-800',
  ADVANCE_PARTIAL: 'bg-yellow-100 text-yellow-800',
  FULL_PAID: 'bg-green-100 text-green-800',
};

const DESCRIPTIONS = {
  PENDING: 'Not yet started / awaiting the next step.',
  PARTIAL: 'In progress — some items billed or delivered, not all.',
  COMPLETED: 'All items billed and every delivery order completed.',
  CANCELLED: 'Cancelled; no further action needed.',
  REJECTED: 'Rejected — no action is being taken.',
  'to-be-reserved': 'In stock and held for this customer; ready to be billed.',
  'to-be-ordered': 'Not in stock; needs a purchase indent / ordering.',
  'to-be-billed': 'Ready to bill and available for a delivery order.',
  'goods-received': 'Stock has arrived and is held (reserved) for this customer.',
  TOTAL_CREDIT: 'Full amount on credit; nothing paid yet.',
  ADVANCE_PARTIAL: 'Partially paid; a balance is still due.',
  FULL_PAID: 'Paid in full.',
};

const humanize = (value) =>
  String(value || '').replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const StatusBadge = ({ status, label, className = '' }) => {
  const style = STATUS_STYLES[status] || 'bg-gray-100 text-gray-800';
  const text = label || humanize(status);
  return (
    <span
      className={`inline-flex px-2 py-0.5 text-xs font-medium rounded-full cursor-help ${style} ${className}`}
      title={DESCRIPTIONS[status] || text}
    >
      {text}
    </span>
  );
};

export default StatusBadge;
